import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { UserProfileDto } from '../models/user-profile.model';
import { LocalStorageService } from '../services/local-storage.service';
import { UserProfileService } from '../services/user-profile.service';
import { TeacherDialogComponent, TeacherDialogData } from './teacher-dialog/teacher-dialog.component';

@Component({
  selector: 'app-teachers',
  templateUrl: './teachers.component.html',
  styleUrls: ['./teachers.component.css']
})
export class TeachersComponent implements OnInit {

  tenantId: number | null = null;
  schoolName = '';

  dataSource = new MatTableDataSource<UserProfileDto>([]);
  displayedColumns: string[] = ['name', 'username', 'email', 'phoneNumber'];
  loadingList = false;

  constructor(
    private userProfileService: UserProfileService,
    private localStorage: LocalStorageService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.tenantId = this.localStorage.getTenantId();
    this.schoolName = this.localStorage.getSchoolDisplayName() || '';
    this.loadTeachers();
  }

  loadTeachers(): void {
    this.loadingList = true;
    this.userProfileService.listUsers().subscribe(
      rows => {
        const list = rows || [];
        this.dataSource.data = list.filter(r => this.hasTeacherRole(r));
        this.loadingList = false;
      },
      () => {
        this.dataSource.data = [];
        this.loadingList = false;
      }
    );
  }

  private hasTeacherRole(row: UserProfileDto): boolean {
    return (row.roles || []).some(r => r === 'ROLE_TEACHER');
  }

  openAddTeacher(): void {
    if (this.tenantId == null) {
      this.snackBar.open('Missing school (tenant) id. Log in again after the API returns tenant or JWT claim.', 'Dismiss', { duration: 5000 });
      return;
    }
    const data: TeacherDialogData = { tenantId: this.tenantId, allowRoleChoice: false };
    this.dialog.open(TeacherDialogComponent, {
      width: '520px',
      maxHeight: '90vh',
      data
    }).afterClosed().subscribe(saved => {
      if (saved) {
        this.snackBar.open('Teacher account created.', 'Dismiss', { duration: 4000 });
        this.loadTeachers();
      }
    });
  }
}
